import { render, staticRenderFns } from "./SetBrandPriceRow.vue?vue&type=template&id=54e8b30b&scoped=true&"
import script from "./SetBrandPriceRow.vue?vue&type=script&lang=js&"
export * from "./SetBrandPriceRow.vue?vue&type=script&lang=js&"
import style0 from "./SetBrandPriceRow.vue?vue&type=style&index=0&id=54e8b30b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8b30b",
  null
  
)

export default component.exports